import {
  Box,
  Grid,
  Card,
  CardContent,
  CardActions,
  Button,
  Typography,
} from '@mui/material'
import SettingsApplicationsIcon from '@mui/icons-material/SettingsApplications'
import MenuBookIcon from '@mui/icons-material/MenuBook'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const ConfigPage: React.FC = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const options = [
    {
      key: 'system',
      title: t('config.options.system.title'),
      description: t('config.options.system.description'),
      icon: <SettingsApplicationsIcon fontSize="large" color="primary" />,
      action: () => navigate('/config'),
      disabled: true,
      buttonText: t('config.options.system.comingSoon'),
    },
    {
      key: 'branding',
      title: t('config.options.branding?.title') || 'Branding',
      description: t('config.options.branding?.description') || 'Logo do header e watermark do fundo.',
      icon: <SettingsApplicationsIcon fontSize="large" color="primary" />,
      action: () => navigate('/config/branding'),
      disabled: false,
      buttonText: t('config.options.open'),
    },
    {
      key: 'appearance',
      title: t('config.options.appearance?.title') || 'Aparência',
      description: t('config.options.appearance?.description') || 'Escolha o tema e o modo de cor.',
      icon: <SettingsApplicationsIcon fontSize="large" color="primary" />,
      action: () => navigate('/config/aparencia'),
      disabled: false,
      buttonText: t('config.options.open'),
    },
    {
      key: 'dicionariothor',
      title: t('config.options.dicionario.title'),
      description: t('config.options.dicionario.description'),
      icon: <MenuBookIcon fontSize="large" color="primary" />,
      action: () => navigate('/config/dicionariothor'),
      disabled: false,
      buttonText: t('config.options.open'),
    },
  ]

  return (
    <Box sx={{ py: 4, px: { xs: 2, md: 3 }, width: '100%' }}>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        {t('config.subtitle')}
      </Typography>
      <Grid container spacing={3}>
        {options.map((option) => (
          <Grid item xs={12} md={6} key={option.key}>
            <Card
              variant="outlined"
              sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
              }}
            >
              <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <Box sx={{ mr: 2 }}>{option.icon}</Box>
                  <Typography variant="h6">{option.title}</Typography>
                </Box>
                <Typography variant="body2" color="text.secondary">
                  {option.description}
                </Typography>
              </CardContent>
              <CardActions sx={{ justifyContent: 'flex-end', px: 3, pb: 3 }}>
                <Button
                  variant="contained"
                  onClick={option.action}
                  disabled={option.disabled}
                >
                  {option.buttonText}
                </Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  )
}

export default ConfigPage
